import Keycloak from 'keycloak-js';

const urlMap = new Map<string, string>([
    ['https://staging-app.passeggeroalsicuro.com', 'https://staging-auth.passeggeroalsicuro.com/auth'],
    ['https://app.passeggeroalsicuro.com', 'https://auth.passeggeroalsicuro.com/auth'],
    ['http://localhost:3000', 'http://localhost:8081/auth'],
])

export const keycloak = new Keycloak({
    realm: "passeggeroalsicuro",
    url: urlMap.get(window.location.origin),
    clientId: "frontend",
})
